import { merge } from 'ramda'

import {
  SET_WEBVIEW,
  LOGOUT,
  SWITCH_METER_REQUEST,
  SWITCH_METER_SUCCESS,
  CLOSE_SWITCH_MODAL,
  IN_APP_MESSAGES_SUCCESS,
  SHOW_MESSAGES_INBOX,
} from './constants'

export const initialState = {
  webView: null,
  logout: false,
  switchMeter: null,
  inAppMessages: [],
  showMessagesInbox: false,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_WEBVIEW:
      return merge(state, {
        webView: action.payload,
      })

    case LOGOUT: {
      return { ...state, logout: true }
    }

    case SWITCH_METER_REQUEST: {
      const { nextMeterNum } = action.payload
      return {
        ...state,
        switchMeter: { isSwitching: true, nextMeterNum },
      }
    }

    case SWITCH_METER_SUCCESS: {
      return { ...state, switchMeter: { isSwitching: false } }
    }

    case CLOSE_SWITCH_MODAL: {
      return { ...state, switchMeter: null }
    }

    case IN_APP_MESSAGES_SUCCESS: {
      return {
        ...state,
        ...action.payload,
      }
    }

    case SHOW_MESSAGES_INBOX: {
      return {
        ...state,
        showMessagesInbox: !state.showMessagesInbox,
      }
    }

    default:
      return state
  }
}

export default reducer
